<div class="container my-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <h2 class="fw-bold text-dark mb-1">Indent Details</h2>
      <p class="text-muted small mb-0">View comprehensive indent information</p>
    </div>
    <button class="btn btn-outline-secondary btn-sm" (click)="goBack()">
      ← Back
    </button>
  </div>

  @if (indent) {
    <div>
      <div class="card shadow-sm mb-4 border-0">
        <div class="card-header bg-white border-bottom pb-3">
          <div class="d-flex justify-content-between align-items-start">
            <div>
              <h4 class="fw-bold mb-1" style="color: #37bc6f">
                {{ indent.indentNumber }}
              </h4>
              <small class="text-muted">{{
                indent.date | date : "fullDate"
              }}</small>
            </div>
            @if (indent.status === 'DRAFT') {
              <div
                class="d-flex align-items-center"
                >
                <div class="btn-group" role="group" aria-label="Status toggle">
                  <button
                    type="button"
                    class="btn"
                [ngClass]="{
                  'btn-warning text-dark': !isPosted,
                  'btn-outline-secondary': isPosted
                }"
                    (click)="toggleStatus(false)"
                    >
                    DRAFT
                  </button>
                  <button
                    type="button"
                    class="btn"
                [ngClass]="{
                  'btn-success': isPosted,
                  'btn-outline-secondary': !isPosted
                }"
                    (click)="toggleStatus(true)"
                    >
                    POSTED
                  </button>
                </div>
                <button
                  class="btn btn-success btn-md ms-3"
                  [disabled]="!isPosted"
                  (click)="saveStatus()"
                  >
                  Save
                </button>
              </div>
            }
            @if (indent.status !== 'DRAFT') {
              <span
                class="badge fs-6 px-3 py-2 rounded-pill"
            [ngClass]="{
              'bg-success':
                indent.status === 'GENERATED' || indent.status === 'POSTED',
              'bg-warning text-dark': indent.status === 'Pending',
              'bg-danger': indent.status === 'Rejected',
              'bg-secondary': ![
                'GENERATED',
                'POSTED',
                'Pending',
                'Rejected'
              ].includes(indent.status)
            }"
                >
                {{ indent.status }}
              </span>
            }
          </div>
        </div>
        <div class="card-body">
          <div class="row g-4">
            <div class="col-md-4">
              <div class="border-start border-primary border-4 ps-3">
                <small class="text-muted text-uppercase fw-semibold"
                  >Location</small
                  >
                  <p class="mb-0 fw-semibold">{{ indent.locationName }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row g-4 mb-4">
          <div class="col-lg-7">
            <div class="card shadow-sm h-100 border-0">
              <div class="card-header bg-light">
                <h6 class="fw-bold mb-0 text-dark">🏪 Store Information</h6>
              </div>
              <div class="card-body">
                <div class="row g-3">
                  <div class="col-12">
                    <small class="text-muted text-uppercase fw-semibold"
                      >Store Name</small
                      >
                      <p class="mb-0 fw-semibold h6">{{ indent.store?.name }}</p>
                    </div>
                    <div class="col-sm-6">
                      <small class="text-muted text-uppercase fw-semibold"
                        >Store Code</small
                        >
                        <p class="mb-0 fw-semibold">
                          <span class="badge bg-light text-dark border">{{
                            indent.store?.code
                          }}</span>
                        </p>
                      </div>
                      <div class="col-sm-6">
                        <small class="text-muted text-uppercase fw-semibold"
                          >City</small
                          >
                          <p class="mb-0 fw-semibold">{{ indent.store?.city }}</p>
                        </div>
                        <div class="col-12">
                          <small class="text-muted text-uppercase fw-semibold"
                            >Address</small
                            >
                            <p class="mb-0">{{ indent.store?.address }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5">
                    <div class="card shadow-sm h-100 border-0">
                      <div class="card-header bg-light">
                        <h6 class="fw-bold mb-0 text-dark">🏢 Department Information</h6>
                      </div>
                      <div class="card-body">
                        <div class="row g-3">
                          <div class="col-12">
                            <small class="text-muted text-uppercase fw-semibold"
                              >Department Name</small
                              >
                              <p class="mb-0 fw-semibold h6">
                                {{ indent.department?.name }}
                              </p>
                            </div>
                            <div class="col-12">
                              <small class="text-muted text-uppercase fw-semibold"
                                >Department Code</small
                                >
                                <p class="mb-0 fw-semibold">
                                  <span class="badge bg-light text-dark border">{{
                                    indent.department?.code
                                  }}</span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card shadow-sm border-0">
                      <div
                        class="card-header bg-light d-flex justify-content-between align-items-center"
                        >
                        <h6 class="fw-bold mb-0 text-dark">📋 Items List</h6>
                        <span class="badge bg-secondary rounded-pill">
                          {{ indent?.items?.length || 0 }} Items
                        </span>
                      </div>
                      <div class="card-body p-0">
                        <div class="table-responsive">
                          <table class="table table-hover mb-0">
                            <thead class="table-light">
                              <tr>
                                <th class="fw-semibold text-muted border-0 py-2">#</th>
                                <th class="fw-semibold text-muted border-0 py-2">Item Name</th>
                                <th class="fw-semibold text-muted border-0 py-2">SKU</th>
                                <th class="fw-semibold text-muted border-0 py-2 text-end">
                                  Indent Quantity
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (item of indent?.items; track item; let i = $index) {
                                <tr
                                  class="border-bottom"
                                  >
                                  <td class="py-2 text-muted fw-semibold">{{ i + 1 }}</td>
                                  <td class="py-2 fw-semibold">{{ item.itemName }}</td>
                                  <td class="py-2">
                                    <span class="badge bg-light text-dark border">{{
                                      item?.product?.sku || item.sku
                                    }}</span>
                                  </td>
                                  <td class="py-2 text-end">
                                    <span
                                      class="badge bg-info bg-opacity-25 text-info fw-semibold px-3 py-2"
                                      >
                                      {{ item.indentQuantity }}
                                    </span>
                                  </td>
                                </tr>
                              }
                              @if (!indent?.items?.length) {
                                <tr>
                                  <td colspan="5" class="text-center py-5">
                                    <div class="text-muted">
                                      <div class="display-4 mb-3">📦</div>
                                      <p class="fw-semibold mb-1">No items available</p>
                                      <small>This indent doesn't contain any items yet.</small>
                                    </div>
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                }

                @if (!indent) {
                  <div class="text-center py-5">
                    <div class="spinner-border text-primary mb-3" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="text-muted fw-semibold">Loading indent details...</p>
                  </div>
                }
              </div>
